fragment flexibleBigLinks on flexibleSections_bigLinks_BlockType {
    __typename

    ... on flexibleSections_bigLinks_BlockType {
        id
        biglinks {
            ... on bigLinks_Entry {
                id
                label
                linkedEntry {
                    id
                    uri
                    slug
                }
            }
        }
    }
}
